const getWindowLocation = () => {
  if (typeof window === 'undefined') return { protocol: 'https:', host: 'www.sainoo.com' };
  return window.location;
};

export const hasSubDomain = () => {
  const { host } = getWindowLocation();
  return host.split('.')[2] && host.split('.')[0] !== 'www';
};

export const getFullUrl = (slug: string, path = '') => {
  const { host, protocol } = getWindowLocation();
  const parts = host.split('.');
  let baseDomain = host;
  let targetSubdomain = slug || 'www';

  if (hasSubDomain() || parts[0] === 'www') {
    baseDomain = parts.slice(1).join('.');
  } else if (parts.length === 1) {
    targetSubdomain = slug;
  }

  const prefix = targetSubdomain ? `${targetSubdomain}.` : '';
  return `${protocol}//${prefix}${baseDomain}${path}`;
};

export function checkIsURLPointToImage(url: string) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}